





















import { Component, Vue, Prop } from 'vue-property-decorator';
import PrivateLink from '@/components/parts/catalog/list/item/components/Link.vue';
import { MoreButton, Badge } from './components';
import { RawLocation, IVacanciesCard } from './types';
import { AppHeading, AppText, AppColorBadge } from '@/uikit';

@Component({
  components: {
    PrivateLink,
    MoreButton,
    Badge,
    AppText,
    AppHeading,
    AppColorBadge,
  },
})
export default class VacanciesCard extends Vue implements IVacanciesCard {
  @Prop({ type: String, default: '' })
  readonly id: string;

  @Prop({ type: String, default: '' })
  readonly vacancy: string;

  @Prop({ type: String, default: '' })
  readonly salary: string;

  @Prop({ type: String, default: '' })
  readonly organization: string;

  @Prop({ type: String, default: '' })
  readonly organizationAddress: string;

  @Prop({ type: String, default: '' })
  readonly cop_multi_name: string;

  get to(): RawLocation {
    const { id } = this;
    return {
      name: 'vacancy',
      params: {
        id: String(id),
      },
    };
  }
  get copMultiDict() {
    return this.$store.state.copMultiDict;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/vacancies/card/Card.vue